let a = 0;
$(window).scroll(function() {

  if ($(window).width() >= 1200) {
    let oTop = $('.js-counter').offset().top - window.innerHeight;
    if (a == 0 && $(window).scrollTop() > oTop) {
      $('.js-counter-value').each(function() {
        let $this = $(this),
          countTo = $this.attr('data-count');
        $({
          countNum: $this.text()
        }).animate({
            countNum: countTo
          },

          {

            duration: 3000,
            easing: 'swing',
            step: function() {
              $this.text(Math.floor(this.countNum));
            },
            complete: function() {
              $this.text(this.countNum);
            }

          });
      });
      a = 1;
    }
  }

});

if ($(window).width() < 1200) { 
  $('.js-counter-value').each(function() {
    let value = $(this).data('count');
    $(this).text(value);
  })
}

const animateScroll = () => {
    let sectionsAnim = document.querySelectorAll('.js-anim');

    window.onscroll = () => {
        if (!document.querySelectorAll('.js-anim:not(.visible)')) return;

        for (const section of sectionsAnim) {
            if (section.getBoundingClientRect().top <= window.innerHeight * 0.75 && section.getBoundingClientRect().top > 0) {
                section.classList.add('visible');
            }
        }
    }
}

D.addEventListener("DOMContentLoaded", function() {
    animateScroll();
})